import { defineComponent, h } from 'vue';
import utils from '../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '@/Application/event-bus';
//import { QAvatar } from 'quasar';
import CalendarRange from './vuecontrols/CalendarRange.vue';

export default defineComponent({
    name: 'calendar-range-picker',
    components: { CalendarRange },
    mixins: [BaseComponent],
    data: function () {
        return {
            startDateValue: '2026-04-01T00:00:00.000Z',
            endDateValue: '2026-04-01T00:00:00.000Z',
        }
    },
    created() {

    },
    computed: {
        StartDate() {
            return this.startDateValue?.substr(0, 10);
        },
        EndDate() {
            return this.endDateValue?.substr(0, 10);
        },
    },
    methods: {
        preRenderComplete() {
        },
        dateRangeChanged(value) {
            this.startDateValue = value?.startDate;
            this.endDateValue = value?.endDate;
        },
    },
    props: {
    },
    render() {
        try {
            if (!this.todisplay)
                return null;

            return <CalendarRange startDate={this.startDateValue} endDate={this.endDateValue} onChange={this.dateRangeChanged} />
        }
        catch(e) {
            utils.error('Avatar Render failed', e);
            return <div>Avatar Failed to Render {e}</div>;
        }
    }
});